import React, {useEffect, useState} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import { PastReportRow } from "../../pages/PASTREPORT/PastReportModel"
import { ApolloContext } from "../../atom/Apollo_Context";
// import {APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_GROUP_ADMIN} from "../../atom/Apollo_Authorization";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import { 
  apollo_past_report_download_path,
} from "../../atom/Apollo_links";
// メッセージ定義
import {
  GetMessage,
  UI_REPORT_DOWNLOAD,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import IconButton from "@material-ui/core/IconButton"

import { Buffer } from 'buffer';

const ApolloReportDownload: React.FC<{ report: PastReportRow }> = ({ report }) => {
  // コンテクスト
  const { state } = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  // const [rows, setRows] = useState<BillingReport[]>([]);
  const [download, setDownload] = useState(0);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const disabled = !report?.reportFileUrl;
  const title = disabled ? "レポートが存在しないため、ダウンロード出来ません" : "CSVダウンロード";

  // 取得データをCSVデータで返却する
  const dataToCsvBlob = (data: any): Blob => {
    // BASE64でコード
    let buf = Buffer.from(data, 'base64');

    const blob = new Blob([buf], {
        type: 'text/csv'
    })
    return blob
  }
  
  useEffect(() => {
    if (download === 0) return; 
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    const url = apollo_past_report_download_path + "/" + report.pastReportSettingId;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        // setRows(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
        createCsv(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_REPORT_DOWNLOAD,"E","0"),
            loading: false
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_REPORT_DOWNLOAD,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [download]);

  // ダウンロードハンドラ
  const handleDownload = () => {
    setDownload(download+1);
  }

  const createCsv = (data:any) => {
    const blob = dataToCsvBlob(data)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = report.reportFileName ? report.reportFileName : "none.csv";
    link.click();
  }

  return (
    <Tooltip title={title} placement="bottom-end">
      <span>
        <IconButton
          aria-label="download"
          onClick={() => handleDownload()}
          disabled={disabled}
        >
          <CloudDownloadIcon color={disabled ? "disabled" : "primary"} />
        </IconButton>
      </span>
    </Tooltip>
  )
}
export default ApolloReportDownload;